import { Component, OnInit } from '@angular/core';
import {trigger, state, style, animate, transition} from '@angular/animations';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

@Component({
  selector: 'sidebar-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
  animations: [
    trigger('toggleUserMenu', [
      state('void', style({
        height: '0',
        opacity: '0'
      })),
      state('true', style({
        height: '*',
        opacity: '1'
      })),
      transition(':enter', animate('200ms ease-in')),
      transition(':leave', animate('200ms ease-out'))
    ])
  ]
})
export class UserComponent implements OnInit {
  userMenu: boolean = false;
  userInfo : any;

  constructor(
    private router : Router
  ) { }

  ngOnInit() {
    this.getOnlineUser()
  }

  getOnlineUser(){
    if(localStorage.getItem("user_info") !== null){
      this.userInfo = JSON.parse(localStorage.getItem("user_info"))
    }
  }

  onUserLogout(){
    if(localStorage.getItem("user_info") !== null){
      localStorage.removeItem("user_info")
      this.router.navigate([''])

    }
  }
}
